import { supabase } from './supabase';

const SYSTEM_EMAIL = 'system@resuswipe.com';
const SYSTEM_NAME = 'ResuSwipe System';

export async function getOrCreateSystemEmployer(): Promise<string | null> {
  console.log('[SystemEmployer] Getting or creating system employer account...');

  const { data: existingProfile, error: searchError } = await supabase
    .from('profiles')
    .select('id, email, full_name, role')
    .eq('email', SYSTEM_EMAIL)
    .maybeSingle();

  if (searchError) {
    console.error('[SystemEmployer] Error searching for existing profile:', searchError);
    return null;
  }

  if (existingProfile) {
    console.log('[SystemEmployer] Found existing system employer:', existingProfile.id);

    if (existingProfile.role !== 'employer') {
      console.log('[SystemEmployer] Updating role to employer...');
      const { error: updateError } = await supabase
        .from('profiles')
        .update({ role: 'employer' })
        .eq('id', existingProfile.id);

      if (updateError) {
        console.error('[SystemEmployer] Error updating role:', updateError);
      }
    }

    return existingProfile.id;
  }

  console.log('[SystemEmployer] System employer does not exist. Creating auth user...');

  const tempPassword = `System-${Date.now()}-${Math.random().toString(36).slice(2)}`;

  const { data: authData, error: authError } = await supabase.auth.signUp({
    email: SYSTEM_EMAIL,
    password: tempPassword,
    options: {
      data: {
        full_name: SYSTEM_NAME,
        role: 'employer',
      },
    },
  });

  if (authError) {
    console.error('[SystemEmployer] Error creating auth user:', authError);
    return null;
  }

  if (!authData.user) {
    console.error('[SystemEmployer] No user returned from signup');
    return null;
  }

  console.log('[SystemEmployer] Created system employer auth user:', authData.user.id);

  await new Promise(resolve => setTimeout(resolve, 2000));

  const { data: newProfile, error: profileError } = await supabase
    .from('profiles')
    .select('id')
    .eq('id', authData.user.id)
    .maybeSingle();

  if (profileError || !newProfile) {
    console.error('[SystemEmployer] Error verifying profile creation:', profileError);
    return null;
  }

  console.log('[SystemEmployer] System employer profile created successfully:', newProfile.id);
  return newProfile.id;
}

export async function getSystemEmployerId(): Promise<string | null> {
  const { data: profile, error } = await supabase
    .from('profiles')
    .select('id')
    .eq('email', SYSTEM_EMAIL)
    .eq('role', 'employer')
    .maybeSingle();

  if (error || !profile) {
    console.log('[SystemEmployer] System employer not found, will need to create it');
    return null;
  }

  return profile.id;
}
